import TripPlannerSnackbarHost from 'tripPlanner/components/Snackbar/TripPlannerSnackbarHost'
import TripChatDesktopSurface, { type TripChatDesktopSurfaceProps } from './surfaces/TripChatDesktopSurface'
import TripChatMobileSurface, { type TripChatMobileSurfaceProps } from './surfaces/TripChatMobileSurface'

export type TripChatSurface = 'desktop' | 'mobile'

type TripChatSurfaceRouterProps =
  | { surface: 'desktop'; desktopSurfaceProps: TripChatDesktopSurfaceProps }
  | { surface: 'mobile'; mobileSurfaceProps: TripChatMobileSurfaceProps }

function TripChatSurfaceRouter(props: TripChatSurfaceRouterProps) {
  // The snackbar host lives here rather than inside a surface: mobile and desktop compose
  // themselves independently, and both raise trip planner snackbars.
  return (
    <>
      {props.surface === 'mobile'
        ? <TripChatMobileSurface {...props.mobileSurfaceProps} />
        : <TripChatDesktopSurface {...props.desktopSurfaceProps} />}
      <TripPlannerSnackbarHost />
    </>
  )
}

export default TripChatSurfaceRouter
